import { getDefaultFulfillmentProfile } from '@/utilities/fulfillment';

import { ActiveOfferContent } from '@/server/services/vendor/models';

export const resolveSelectedSeller = (winner: ActiveOfferContent, allStores: ActiveOfferContent[], preferredStoreUuid?: string) => {
    const isSelectable = (store: ActiveOfferContent) => store.availableQuantity > 0 && Boolean(getDefaultFulfillmentProfile(store));
    const preferredStore = allStores.find((store) => store.storeUuid === preferredStoreUuid && isSelectable(store));

    return preferredStore ?? (isSelectable(winner) ? winner : allStores.find(isSelectable)) ?? winner;
};
